import { buildMiddleware } from 'utilities/state';

const stateKey = 'auth';
const storeKey = 'store:auth';

function serialize(appStore, state) {
    const { loginDateTime } = (state.auth || {});
    appStore.set(storeKey, { ...loginDateTime });
}

function deserialize(appStore, state) {
    const storedState = appStore.get(storeKey) || {};

    state[stateKey] = storedState;
}


export default buildMiddleware(serialize, deserialize);